// In order to perform an action of type LOGIN_REQUEST
import { EmailCredential } from "types/payload"
import { OwnerInfoDraft, OwnerInfoField } from "types/store"
import { Action, ActionWithoutPayload, Message } from "types/redux"
import {
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_ERROR,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGOUT,
  ADMIN_BILLING_REQUEST,
  ADMIN_BILLING_SUCCESS,
  ADMIN_BILLING_ERROR,
  ADMIN_OWNER_INFO_UPDATE_REQUEST,
  ADMIN_OWNER_INFO_UPDATE_SUCCESS,
  ADMIN_OWNER_INFO_UPDATE_ERROR,
  ADMIN_OWNER_INFO_UPDATE_INCOMPLETE,
  ADMIN_OWNER_INFO_RESET,
} from "./constants"

export const adminLoginRequest = (
  payload: EmailCredential
): Action<EmailCredential> => ({
  type: ADMIN_LOGIN_REQUEST,
  payload,
})

export const adminLoginError = (error: string): Action<Message> => ({
  type: ADMIN_LOGIN_ERROR,
  payload: { text: error, type: "error" },
})

export const adminLoginSuccess = (payload: string): Action<Message> => ({
  type: ADMIN_LOGIN_SUCCESS,
  payload: { text: payload, type: "success" },
})

export const adminLogout = (): ActionWithoutPayload => ({
  type: ADMIN_LOGOUT,
})

export const adminBillingRequest = (payload: { rpps: string, finess: string, owner_firstname: string, owner_lastname: string }): Action<{ rpps: string, finess: string, owner_firstname: string, owner_lastname: string }> => ({
  type: ADMIN_BILLING_REQUEST,
  payload,
})

export const adminBillingSuccess = (payload: string): Action<Message> => ({
  type: ADMIN_BILLING_SUCCESS,
  payload: { text: payload, type: "success" },
})

export const adminBillingError = (error: string): Action<Message> => ({
  type: ADMIN_BILLING_ERROR,
  payload: { text: error, type: "error" },
})

export const adminOwnerInfoUpdateRequest = (
  payload: OwnerInfoDraft
): Action<OwnerInfoDraft> => ({
  type: ADMIN_OWNER_INFO_UPDATE_REQUEST,
  payload,
})

export const adminOwnerInfoUpdateSuccess = (text: string): Action<Message> => ({
  type: ADMIN_OWNER_INFO_UPDATE_SUCCESS,
  payload: { text, type: "success" },
})

export const adminOwnerInfoUpdateError = (text: string): Action<Message> => ({
  type: ADMIN_OWNER_INFO_UPDATE_ERROR,
  payload: { text, type: "error" },
})

export const adminOwnerInfoUpdateIncomplete = (payload: {
  missing: OwnerInfoField
  draft: OwnerInfoDraft
}): Action<{ missing: OwnerInfoField; draft: OwnerInfoDraft }> => ({
  type: ADMIN_OWNER_INFO_UPDATE_INCOMPLETE,
  payload,
})

export const adminOwnerInfoReset = (): ActionWithoutPayload => ({
  type: ADMIN_OWNER_INFO_RESET,
})
